import { render, staticRenderFns } from "./LeadCounts.vue?vue&type=template&id=6b8472f8&"
import script from "./LeadCounts.vue?vue&type=script&lang=js&"
export * from "./LeadCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports